var O = /* @__PURE__ */ ((T) => (T.TOP = "TOP", T.BOTTOM = "BOTTOM", T))(O || {}), r = /* @__PURE__ */ ((T) => (T.LEFT = "LEFT", T.MIDDLE = "MIDDLE", T.RIGHT = "RIGHT", T))(r || {});
export {
  r as FloatingElementHorizontalPosition,
  O as FloatingElementVerticalPosition
};
